<app-tdo-progress-spinner *ngIf="isLoading" data-cy="insurance-coverage-loading"></app-tdo-progress-spinner>
<div *ngIf="!isLoading" class="section" style="flex: 1; display: flex; flex-direction: column;" data-cy="insurance-coverage-container">
  <div class="section-header" data-cy="insurance-coverage-header">
    <div class="section-header-title" data-cy="insurance-coverage-title">Coverages for {{ this.insuranceDescription + ' | ' + this.dataPatientInsurance.GroupNO + ' ' + this.dataPatientInsurance.EmployerNO }}</div>
  </div>
  <div class="section-content" data-cy="insurance-coverage-content">

    <div style="padding: 10px 10px 10px 10px; border:solid 1px #cccccc" data-cy="insurance-coverage-wizard-container">

      <div data-cy="insurance-coverage-wizard">
        <table style="width:100%" data-cy="insurance-coverage-wizard-table">
          <tr data-cy="insurance-coverage-wizard-row">
            <td valign="middle" data-cy="insurance-coverage-wizard-title-cell">
              <h5 data-cy="insurance-coverage-wizard-title">Update Wizard</h5>
            </td>
            <td data-cy="insurance-coverage-preventative-cell">
              <table data-cy="insurance-coverage-preventative-table">
                <tr data-cy="insurance-coverage-preventative-row">
                  <td data-cy="insurance-coverage-preventative-label">Preventitive (A)</td>
                  <td data-cy="insurance-coverage-preventative-input-cell">
                    <div class="wizard-field" data-cy="insurance-coverage-preventative-field">
                      <mat-form-field class="wizard-input" data-cy="insurance-coverage-preventative-form-field">
                        <input matInput [(ngModel)]="updateWizardA" data-cy="insurance-coverage-preventative-input"/>
                      </mat-form-field>%
                    </div>
                  </td>
                </tr>
              </table>
            </td>
            <td data-cy="insurance-coverage-basic-cell">
              <table data-cy="insurance-coverage-basic-table">
                <tr data-cy="insurance-coverage-basic-row">
                  <td data-cy="insurance-coverage-basic-label">Basic (B)</td>
                  <td data-cy="insurance-coverage-basic-input-cell">
                    <div class="wizard-field" data-cy="insurance-coverage-basic-field">
                      <mat-form-field class="wizard-input" data-cy="insurance-coverage-basic-form-field">
                        <input matInput [(ngModel)]="updateWizardB" data-cy="insurance-coverage-basic-input"/>
                      </mat-form-field>%
                    </div>
                  </td>
                </tr>
              </table>
            </td>
            <td data-cy="insurance-coverage-other-cell">
              <table data-cy="insurance-coverage-other-table">
                <tr data-cy="insurance-coverage-other-row">
                  <td data-cy="insurance-coverage-other-label">Other (C)</td>
                  <td data-cy="insurance-coverage-other-input-cell">
                    <div class="wizard-field" data-cy="insurance-coverage-other-field">
                      <mat-form-field class="wizard-input" data-cy="insurance-coverage-other-form-field">
                        <input matInput [(ngModel)]="updateWizardC" data-cy="insurance-coverage-other-input"/>
                      </mat-form-field>%
                    </div>
                  </td>
                </tr>
              </table>
            </td>
            <td data-cy="insurance-coverage-apply-cell">
              <button class="tdo-button tdo-save" (click)="applyWizard()" data-cy="insurance-coverage-apply-button">
                Apply Percentage
              </button>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div style="display: flex; overflow-y: auto; height: 630px; padding: 0px 10px 10px 10px" data-cy="insurance-coverage-grid-container">

      <dx-data-grid   *ngIf="1==1"
        [dataSource]="coverages"
        [height]="610"
        keyExpr="CoverageID"
        (onEditorPreparing)="overrideOnValueChangedTable($event)"
        (onSaving)="onSavingOnTable($event)"
        (onToolbarPreparing)="overrideOnToolbarPreparing($event)"
        data-cy="insurance-coverage-grid"
      >
        <dxo-keyboard-navigation
          [editOnKeyPress]="true"
          [enterKeyAction]="'moveFocus'"
          [enterKeyDirection]="'column'"
        ></dxo-keyboard-navigation>


        <dxo-paging [enabled]="true"  [pageSize]="12"  ></dxo-paging>

        <dxo-filter-row [visible]="true" [applyFilter]="true"></dxo-filter-row>
<!--        <dxo-header-filter [visible]="true"></dxo-header-filter>-->
<!--        <dxo-search-panel [visible]="true" [width]="240" placeholder="Search..."></dxo-search-panel>-->


        <dxo-editing mode="batch"
                     [allowUpdating]="true"
                     [startEditAction]="'click'"
                     [selectTextOnEditStart]="true"
                     [allowAdding]="false"
                     [allowDeleting]="false"
        >
        </dxo-editing>


        <dxi-column dataField="CoverageID" caption="CoverageID" [width]="100" [visible]="false" ></dxi-column>
        <dxi-column dataField="Code" caption="Code" [allowEditing]="false" [width]="100"></dxi-column>
        <dxi-column dataField="Description" caption="Description" [allowEditing]="false" [width]="630"   ></dxi-column>


        <dxi-column dataField="CoveragePCT" caption="PCT" [width]="100"   ></dxi-column>

        <dxi-column dataField="enumFeeItemCategoryId" caption="Category"  [allowEditing]="false"  [allowFiltering]="true" [width]="160">
          <dxo-lookup [dataSource]="enumFeeItemCategories" displayExpr="ItemDisplayValue" valueExpr="ValidValueItemId">
          </dxo-lookup>
        </dxi-column>


<!--        when ready make these two fields visible -->
        <dxi-column [visible]="false" dataField="isNotCovered" caption="NC" dataType="boolean" [width]="50" [calculateCellValue]="checkedNCValue"  ></dxi-column>
        <dxi-column [visible]="false" dataField="isInclusive" caption="Inc." dataType="boolean"  [width]="50" [calculateCellValue]="checkedIncValue"  ></dxi-column>




      </dx-data-grid>



        <tdo-table [dataSource]="coverages"  *ngIf="1==2"
                   [isMultiSelection]="false" [isSearchable]="true" [isUsePaginator]="false"
                   [searchPredicate]="searchPredicate" (rowSelected)="onRowSelected($event)"
                   data-cy="insurance-coverage-table">

          <tdo-table-column displayName="Code" propertyName="Code" isSortable="true" [rowTemplate]="code" data-cy="insurance-coverage-code-column">
            <ng-template #code let-row>
              <div *ngIf="row.model.Code" data-cy="insurance-coverage-code-cell-{{row.index}}">{{ row.model.Code }}</div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Description" propertyName="Description" isSortable="true" [rowTemplate]="desc" data-cy="insurance-coverage-description-column">
            <ng-template #desc let-row>
              <div *ngIf="row.model.Description" data-cy="insurance-coverage-description-cell-{{row.index}}">{{ row.model.Description }}</div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Category" propertyName="enumFeeItemCategoryId" isSortable="true" [rowTemplate]="cat" data-cy="insurance-coverage-category-column">
            <ng-template #cat let-row>
              <div style="width: 120px" *ngIf="row.model.enumFeeItemCategoryId" data-cy="insurance-coverage-category-cell-{{row.index}}">{{ returnEnumFeeItemCategory(row.model.enumFeeItemCategoryId) }}</div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="" propertyName="CoverageAmount" [rowTemplate]="amount" data-cy="insurance-coverage-amount-column">
            <ng-template #amount let-row>
              <div class="input-container-height" data-cy="insurance-coverage-amount-cell-{{row.index}}">
                <mat-form-field style="width: 80px" data-cy="insurance-coverage-amount-form-field-{{row.index}}">
                  <input matInput
                         *ngIf="row.model.enumFeeCoverageCalcTypeId == enumCalcTypeMoney"
                         (keyup)="this.changesMade = true; row.model.changed = true"
                         [ngModel]="row.model.CoverageAmount | currency"
                         (change)="onCoverageAmountChange(row.model, $event)"
                         data-cy="insurance-coverage-amount-money-input-{{row.index}}"/>
                  <input matInput
                         *ngIf="row.model.enumFeeCoverageCalcTypeId == enumCalcTypePerc"
                         (keyup)="this.changesMade = true; row.model.changed = true"
                         [(ngModel)]="row.model.CoveragePCT"
                         data-cy="insurance-coverage-amount-percent-input-{{row.index}}"/>
                </mat-form-field>
              </div>
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Calc" propertyName="PatientResponsibility" [rowTemplate]="calc" data-cy="insurance-coverage-calc-column">
            <ng-template #calc let-row>
              <div class="input-container-height" data-cy="insurance-coverage-calc-cell-{{row.index}}">
                <mat-form-field data-cy="insurance-coverage-calc-form-field-{{row.index}}">
                  <mat-select
                    [(ngModel)]="row.model.enumFeeCoverageCalcTypeId"
                    (ngModelChange)="this.changesMade = true; row.model.changed = true"
                    data-cy="insurance-coverage-calc-select-{{row.index}}">
                    <mat-option *ngFor="let type of enumCoverageTypes" [value]="type.ValidValueItemId" data-cy="insurance-coverage-calc-option-{{type.ValidValueItemId}}">
                      {{ type.ItemDisplayValue }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </ng-template>
          </tdo-table-column>

          <tdo-table-column displayName="NC" propertyName="isNotCovered" [rowTemplate]="nc" data-cy="insurance-coverage-nc-column">
            <ng-template #nc let-row>
              <div class="input-container-height" data-cy="insurance-coverage-nc-cell-{{row.index}}">
                <mat-form-field style="width: 80px" data-cy="insurance-coverage-nc-form-field-{{row.index}}">
                  <mat-checkbox [(ngModel)]="row.model.isNotCovered" data-cy="insurance-coverage-nc-checkbox-{{row.index}}">
                  </mat-checkbox>

                </mat-form-field>
              </div>
            </ng-template>
          </tdo-table-column>

<!--          <tdo-table-column displayName="Inc." propertyName="isInclusive" [rowTemplate]="inc">-->
<!--            <ng-template #inc let-row>-->
<!--              <div class="input-container-height">-->
<!--                <mat-form-field style="width: 80px">-->
<!--                  <mat-checkbox  [(ngModel)]="row.model.isInclusive">-->
<!--                  </mat-checkbox>-->

<!--                </mat-form-field>-->
<!--              </div>-->
<!--            </ng-template>-->
<!--          </tdo-table-column>-->



        </tdo-table>

    </div>
  </div>
  <div class="section-footer" style="flex-basis: 60px; min-height: 60px; padding-top: 6px;" data-cy="insurance-coverage-footer">
    <div style="flex: 1; margin-right: 6px;"></div>
    <button class="tdo-button tdo-close" style="margin-right: 12px;" (click)="cancel()" data-cy="insurance-coverage-close-button">Close</button>
<!--    <button class="tdo-button tdo-save" style="margin-right: 20px;"-->
<!--            [disabled]="this.changesMade === false"-->
<!--            (click)="saveChanges()">-->
<!--      Save-->
<!--    </button>-->
  </div>
</div>
